import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=0844f488&scoped=true&"
import script from "./SubCategories.vue?vue&type=script&lang=js&"
export * from "./SubCategories.vue?vue&type=script&lang=js&"
import style0 from "./SubCategories.vue?vue&type=style&index=0&id=0844f488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0844f488",
  null
  
)

export default component.exports